<template>
  <div>
    <h1>{{ $t("settings.documentTemplate.listTitle") }}</h1>

    <v-row class="mb-3">
      <v-col cols="3">
        <v-text-field :label="$t('global.search')" append-icon="search" hide-details single-line v-model="search"></v-text-field>
      </v-col>
      <v-spacer></v-spacer>
      <div>
        <v-btn block color="accent" to="/settings/system-settings/document-number-template/new">{{ $t("settings.documentTemplate.addNew") }} </v-btn>
      </div>
    </v-row>

    <v-data-table :headers="headers" :items="documentNumberTemplates" :search="search">
      <template #item="props">
        <tr>
          <td class="text-left">{{ props.item.template_mask }}</td>
          <td class="text-left">
            {{ documentType.filter(elem => elem.value === props.item.document_type)[0].text }}
          </td>
          <td class="text-left">
            {{ numberType.filter(elem => elem.value === props.item.number_type)[0].text }}
          </td>
          <td class="text-center">
            <v-tooltip bottom>
              {{ $t("global.edit") }}
              <template #activator="{on}">
                <v-btn :to="'/settings/system-settings/document-number-template/edit/' + props.item.id" class="mx-0" icon v-on="on">
                  <v-icon>edit</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
            <v-tooltip bottom>
              {{ $t("global.delete") }}
              <template #activator="{on}">
                <v-btn :disabled="$store.getters['Ajax/loading']" @click="deleteItem(props.item)" class="mx-0" icon v-on="on">
                  <v-icon>delete</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { documentType, numberType } from "../../../../staticData/DocumentNumberTemplate";

export default {
  name: "DocumentNumberTemplateList",
  data: () => {
    return {
      documentNumberTemplates: [],
      search: ""
    };
  },
  computed: {
    documentType: documentType,
    numberType: numberType,
    headers() {
      return [
        {
          text: this.$t("settings.documentTemplate.mask"),
          value: "template_mask"
        },
        {
          text: this.$t("settings.documentTemplate.documentType"),
          value: "document_type"
        },
        {
          text: this.$t("settings.documentTemplate.numberResetType"),
          value: "number_type"
        },
        { text: this.$t("global.actions"), sortable: false, value: "actions", align: "center" }
      ];
    }
  },
  created() {
    this.axios.get("settings/document-number-template/get-list").then(resp => {
      this.documentNumberTemplates = resp.data;
    });
  },
  methods: {
    deleteItem(item) {
      this.$store
        .dispatch("confirmDialog", {
          content: this.$t("global.removeConfirm.content"),
          title: this.$t("global.removeConfirm.title")
        })
        .then(() => {
          this.axios.get("settings/document-number-template/delete?id=" + item.id).then(() => {
            this.axios.get("settings/document-number-template/get-list").then(resp => {
              this.documentNumberTemplates = resp.data;
            });
          });
        });
    }
  }
};
</script>

<style scoped></style>
